import { render, staticRenderFns } from "./zhbb.vue?vue&type=template&id=4371a11a&scoped=true&"
import script from "./zhbb.vue?vue&type=script&lang=js&"
export * from "./zhbb.vue?vue&type=script&lang=js&"
import style0 from "./zhbb.vue?vue&type=style&index=0&id=4371a11a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4371a11a",
  null
  
)

export default component.exports